var map = {
	"./about-us/index.vue": [
		"0eWr",
		4,
		0
	],
	"./classic-case/caseDetails.vue": [
		"cxHj",
		12,
		0
	],
	"./classic-case/index.vue": [
		"QXz0",
		2,
		0
	],
	"./contrast.vue": [
		"omL+",
		13
	],
	"./desktop.vue": [
		"wpVx",
		1,
		0
	],
	"./join-us/index.vue": [
		"pFhf",
		3,
		0
	],
	"./news/news-center.vue": [
		"D81n",
		11,
		0
	],
	"./news/news-details.vue": [
		"Eoxv",
		6
	],
	"./recruitment/index.vue": [
		"DgAi",
		10,
		0
	],
	"./solutions-and-services/index.vue": [
		"BNm8",
		5,
		0
	],
	"./solutions-and-services/productDetails.vue": [
		"MGAe",
		8,
		0
	],
	"./solutions-and-services/solutionDetails.vue": [
		"D+VL",
		7,
		0
	],
	"./wxUploadPdf.vue": [
		"YEH5",
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "A14c";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*\.vue$
// module id = A14c
// module chunks = 15